<mf-page title="Editar banco">
  @if(valueListDto) {
  <mf-admin-value-list
    [valueListDto]="valueListDto"
    (save)="save($event)" />
  }
</mf-page>
